<i18n>
{
  "ru": {
    "identity": "Проверка документов, удостоверяющих личность",
    "selfie": "Селфи",
    "video_selfie": "Видео селфи",
    "liveness": "Проверка живости",
    "proof_of_residence": "Платёжный документ подтверждающий адрес",
    "payment_methods": "Кредитная карта или крипто кошелёк",
    "passport": "Паспорт",
    "id_card": "ID Карта",
    "residence_permit": "Вид на жительство",
    "drivers": "Права",
    "utility_bill": "Платежный документ"
  },
  "en": {
    "identity": "Identity check",
    "selfie": "Selfie",
    "video_selfie": "Video selfie",
    "liveness": "Livencess",
    "proof_of_residence": "Proof of residence",
    "payment_methods": "Payment methods",
    "passport": "Passport",
    "id_card": "ID Card",
    "residence_permit": "Residence permition",
    "drivers": "Driver license",
    "utility_bill": "Utility bill"
  }
}
</i18n>
<template>
  <el-dialog custom-class="webpay template" :visible.sync="visibleInner" top="1vh">
    <span slot="title" v-if="!loading">
      <h4 v-if="model.id">{{ $t('edit') }}</h4>
      <h4 v-if="!model.id">{{ $t('add') }}</h4>
    </span>
    <div v-loading="loading">
      <el-form ref="templateForm" :show-message="false" :model="model" :rules="rules">
        <el-form-item prop="name">
          <el-input :placeholder="$t('name')" v-model="model.name"></el-input>
        </el-form-item>
        <el-form-item prop="descr">
          <el-input :placeholder="$t('title_description')" v-model="model.descr"></el-input>
        </el-form-item>
        <div class="el-table__body-wrapper is-scrolling-none" v-if="!editJson">
          <table class="el-table__body" style="width: 100%">
            <colgroup>
              <col width="60px" />
              <col />
              <col width="300px" />
            </colgroup>
            <thead>
              <tr>
                <td class="text-left">
                  <el-button
                    class="el-icon-circle-plus-outline"
                    @click="addStep"
                    :disabled="model.docSets.length > 3"
                    circle
                  ></el-button>
                </td>
                <th class="text-center">{{ $t('doc_set') }}</th>
                <th class="text-center">{{ $t('doc_type') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="el-table__row" v-for="(step, index) in model.docSets" :key="index">
                <td class="text-left">
                  <el-button
                    class="el-icon-delete"
                    @click="model.docSets.splice(index, 1)"
                    :disabled="!index"
                    circle
                  ></el-button>
                </td>
                <td class="text-center">
                  <div class="responsive-column" :data-label="$t('doc_set')">
                    <el-select style="width: 90%" size="mini" v-model="step.id" @change="step.types = []" filterable>
                      <el-option
                        v-for="option in getStepsOptions(index)"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id"
                      ></el-option>
                    </el-select>
                  </div>
                </td>
                <td class="text-center">
                  <div class="responsive-column" :data-label="$t('doc_type')">
                    <span v-if="step.id == 'proof_of_residence'">{{ $t('utility_bill') }}</span>
                    <div v-if="step.id == 'identity' || step.id == 'identity2'">
                      <el-select
                        style="width: 90%"
                        size="mini"
                        v-model="step.types"
                        filterable
                        multiple
                      >
                        <el-option
                          v-for="option in getIdentityStepsOptions(index)"
                          :key="option.id"
                          :label="option.name"
                          :value="option.id"
                        ></el-option>
                      </el-select>
                    </div>
                    <div v-if="step.id == 'selfie' || step.id == 'selfie2'">
                      <el-select
                        style="width: 90%"
                        size="mini"
                        v-model="step.types"
                        filterable
                        multiple
                        :multiple-limit="1"
                      >
                        <el-option
                          v-for="option in getSelfieStepsOptions(index)"
                          :key="option.id"
                          :label="option.name"
                          :value="option.id"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </td>
                <td>
                  {{ index + 1 }}
                  <el-button
                    icon="el-icon-arrow-up"
                    @click="
                      model.docSets.splice(
                        index - 1,
                        0,
                        model.docSets.splice(index, 1)[0]
                      )
                    "
                    :disabled="!index"
                    circle
                  ></el-button>
                  <el-button
                    icon="el-icon-arrow-down"
                    @click="
                      model.docSets.splice(
                        index + 1,
                        0,
                        model.docSets.splice(index, 1)[0]
                      )
                    "
                    :disabled="index >= model.docSets.length - 1"
                    circle
                  ></el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-row v-if="editJson">
          <el-form-item prop label="docSets">
            <el-input
              v-model="docSetsJsonEdit"
              type="textarea"
              size="medium"
              rows="10"
              resize="none"
            ></el-input>
          </el-form-item>

          <el-form-item prop label="steps">
            <el-input v-model="stepsJsonEdit" type="textarea" size="medium" rows="10" resize="none"></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-button
            round
            type="primary"
            native-type="button"
            @click="hideJson"
            v-if="editJson"
            icon="el-icon-back"
          ></el-button>

          <el-button
            round
            type="primary"
            native-type="button"
            @click="toggleJson"
            :disabled="editJson && !isJsonValid"
          >{{ editJson ? $t('save') : 'JSON' }}</el-button>

          <el-button round type="primary" v-if="!editJson" @click="save">{{ $t('save') }}</el-button>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'template-modal',
  props: ['template', 'callback', 'visible'],
  computed: {
    visibleInner: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    },
    docSetsJson: {
      get() {
        const docSets = this.model.docSets.filter(s => s.id).map(s => {
          return {
            idDocSetType: s.id.toUpperCase(),
            types: s.id.indexOf('identity') === 0 || s.id.indexOf('selfie') === 0
              ? s.types.map(t => t === 'liveness' ? 'SELFIE' : t.toUpperCase())
              : s.id === 'proof_of_residence' ? ['UTILITY_BILL']
                : []
          }
        }).filter(s => s.types.length)

        return JSON.stringify(docSets)
      },
      set(value) {
        try {
          const docSets = JSON.parse(value)
          this.model.docSets = docSets.filter(s => s.idDocSetType).map(s => {
            return {
              id: s.idDocSetType.toLowerCase(),
              types: s.idDocSetType.indexOf('IDENTITY') > -1 || s.idDocSetType.indexOf('SELFIE') > -1 ? s.types.map(t => t.toLowerCase()) : []
            }
          })
        } catch (e) {

        }
      }
    },
    stepsJson: {
      get() {
        let steps = {}
        let docSet = this.model.docSets.find(s => s.types.some(tid => tid === 'liveness'))
        if (docSet) {
          steps[docSet.id.toUpperCase()] = { videoRequired: 'liveness' }
        }

        return JSON.stringify(steps)
      },
      set(value) {
        try {
          const parsed = JSON.parse(value)
          const jsonLiveness = parsed.SELFIE && parsed.SELFIE.videoRequired === 'liveness' ? 'selfie' : parsed.SELFIE2 && parsed.SELFIE2.videoRequired ? 'selfie2' : null

          let livenessIndex = this.model.docSets.findIndex(s => s.types.some(tid => tid === 'liveness'))

          if (livenessIndex > -1 && (!jsonLiveness || this.model.docSets[livenessIndex].id !== jsonLiveness)) {
            this.model.docSets.splice(livenessIndex, 1)
            livenessIndex = -1
          }

          if (livenessIndex === -1 && jsonLiveness) {
            let docSet = this.model.docSets.find(s => s.id === jsonLiveness)
            if (!docSet) {
              this.model.docSets.push({ id: jsonLiveness, types: ['liveness'] })
            } else {
              docSet.types = ['liveness']
            }
          }
        } catch (e) {

        }
      }
    },
    isJsonValid() {
      try {
        return JSON.parse(this.docSetsJsonEdit) && JSON.parse(this.stepsJsonEdit)
      } catch (e) {
        return false
      }
    }
  },
  data() {
    return {
      loading: true,
      editJson: false,
      docSetsJsonEdit: '',
      stepsJsonEdit: '',
      model: { descr: '', name: '', docSets: [] },
      docSetOptions: [{ id: 'identity', name: this.$t('identity') }, { id: 'identity2', name: this.$t('identity') + ' 2' }, { id: 'selfie', name: this.$t('selfie') }, { id: 'selfie2', name: this.$t('selfie') + ' 2' }, { id: 'proof_of_residence', name: this.$t('proof_of_residence') }],
      identityStepsOptions: [{ id: 'passport', name: this.$t('passport') }, { id: 'id_card', name: this.$t('id_card') }, { id: 'residence_permit', name: this.$t('residence_permit') }, { id: 'drivers', name: this.$t('drivers') }],
      selfieStepsOptions: [{ id: 'selfie', name: this.$t('selfie') }, { id: 'video_selfie', name: this.$t('video_selfie') }, { id: 'liveness', name: this.$t('liveness') }],
      rules: {
        name: { required: true, trigger: 'blur' }
      }
    }
  },
  created() {
    this.model.id = this.template.template_id
    this.model.descr = this.template.descr
    this.model.name = this.template.name
    this.docSetsJson = this.template.docSets
    this.stepsJson = this.template.steps
    this.loading = false
  },
  methods: {
    hideJson() {
      this.editJson = false
    },
    toggleJson() {
      this.editJson = !this.editJson
      if (this.editJson) {
        this.docSetsJsonEdit = this.docSetsJson
        this.stepsJsonEdit = this.stepsJson
      } else {
        this.docSetsJson = this.docSetsJsonEdit
        this.stepsJson = this.stepsJsonEdit
      }
    },
    getStepsOptions(index) {
      const selfieIds = ['selfie', 'video_selfie', 'liveness']
      const selfieSelectedCount = this.model.docSets.filter(s => selfieIds.some(id => id === s.id)).length
      return this.docSetOptions.filter(o =>
        (selfieSelectedCount < 2 || !selfieIds.some(id => id === o.id)) &&
        !this.model.docSets.some((s, i) => i !== index && (s.id === o.id))
      )
    },
    getIdentityStepsOptions(index) {
      return this.identityStepsOptions.filter(o => !this.model.docSets.some((s, i) => i !== index && s.id && s.id.indexOf('identity') === 0 && s.types && s.types.some(t => t === o.id)))
    },
    getSelfieStepsOptions(index) {
      return this.selfieStepsOptions.filter(o => !this.model.docSets.some((s, i) => i !== index && s.id && s.id.indexOf('selfie') === 0 && s.types && s.types.some(t => t === o.id)))
    },
    addStep() {
      this.model.docSets.push({ types: [] })
    },
    save() {
      this.$refs['templateForm'].validate(valid => {
        if (valid && JSON.parse(this.docSetsJson).length) {
          this.loading = true
          let toSend = { action: 'save' }
          Object.assign(toSend, { docSets: this.docSetsJson, steps: this.stepsJson, descr: this.model.descr, id: this.model.id, name: this.model.name })
          apiRes
            .post(apiRes.idcheckTemplates, toSend)
            .then(res => {
              if (res.page_vars) {
                this.callback(res.page_vars)
                this.visibleInner = false
              }

              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style>
.el-dialog.webpay.template {
  max-width: 832px;
}
</style>
